import { gql, useMutation } from '@apollo/client';

import { GET_HOLIDAY_LOCATIONS_BY_COMPANY } from './get-holiday-locations-by-company.hook';

export const CREATE_HOLIDAY_SUBGROUP = gql`
  mutation createHolidaySubGroup($payload: CreateHolidaySubGroupInput!) {
    createHolidaySubGroup(payload: $payload) {
      _id
      name
    }
  }
`;

export const useCreateHolidaySubGroup = ({ onSuccess }: { onSuccess: () => void }) => {
  const [createHolidaySubGroup] = useMutation(CREATE_HOLIDAY_SUBGROUP, {
    onCompleted: onSuccess,
    refetchQueries: [GET_HOLIDAY_LOCATIONS_BY_COMPANY],
  });

  return createHolidaySubGroup;
};
